import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const skTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Meno (malé písmená, žiadne špeciálne znaky)',
    add: 'Pridať',
    allowedFileTypes: 'Povolené typy súborov',
    allowedFileTypesDescription:
      'Obmedzte povolené typy súborov (napr. obrázok/*, aplikácia/pdf). Ak chcete povoliť všetky typy, nechajte prázdne.',
    allowMultipleFiles: 'Povoliť viacero súborov',
    amountInCents: 'Suma v centoch',
    basePrice: 'Základná cena',
    bcc: 'BCC',
    brand: 'Značka',
    cc: 'CC',
    checkboxPlural: 'Polia začiarkavacieho políčka',
    checkboxSingular: 'začiarkavacie políčko',
    checkedByDefault: 'Predvolene začiarknuté',
    chooseConfirmationType:
      'Vyberte, či chcete po odoslaní formulára zobraziť správu na stránke alebo presmerovať na inú stránku.',
    condition: 'Podmienka',
    confirmationMessage: 'Potvrdzovacia správa',
    confirmationType: 'Typ potvrdenia',
    countryPlural: 'Polia krajiny',
    countrySingular: 'Krajina',
    creditCard: 'Kreditná karta',
    customURL: 'Vlastná adresa URL',
    datePlural: 'Dátumové polia',
    dateSingular: 'Dátum',
    defaultValue: 'Predvolená hodnota',
    divide: 'Rozdeliť',
    documentToLinkTo: 'Dokument na prepojenie',
    doesNotEqual: 'Nerovná sa',
    emailFrom: 'Email od',
    emailPlural: 'E-mailové polia',
    emailsDescription:
      'Po odoslaní formulára odosielajte vlastné e-maily. Ak chcete odoslať rovnaký e-mail viacerým príjemcom, použite zoznamy oddelené čiarkami. Ak chcete odkazovať na hodnotu z tohto formulára, zabaľte názov poľa do dvojitých zložených zátvoriek, t. j. {{firstName}}. Môžete použiť zástupný znak {{*}} na výstup všetkých údajov a {{*:table}} na formátovanie ako HTML tabuľku v e-maile.',
    emailSingular: 'Email',
    emailTo: 'Email Komu',
    equals: 'Rovná sa',
    field: 'Pole',
    fields: 'Polia',
    fieldWidth: 'Šírka poľa (v percentách)',
    hasAnyValue: 'Má akúkoľvek hodnotu',
    internalLink: 'Interný odkaz',
    label: 'Označenie',
    maxFileSize: 'Maximálna veľkosť súboru (bajty)',
    maxFileSizeDescription: 'Maximálna veľkosť súboru v bajtoch. Nechajte prázdne bez obmedzenia.',
    message: 'Správa',
    messageDescription: 'Zadajte správu, ktorá sa má odoslať v tomto e-maile.',
    messagePlural: 'Bloky správ',
    messageSingular: 'Správa',
    mimeType: 'Typ MIME',
    mimeTypePlural: 'Typy MIME',
    mimeTypeSingular: 'Typ MIME',
    multiply: 'Vynásobte',
    numberPlural: 'Číselné polia',
    numberSingular: 'číslo',
    optionPlural: 'Možnosti',
    optionSingular: 'Možnosť',
    paymentFieldPlural: 'Platobné polia',
    paymentFieldSingular: 'Platba',
    paymentProcessor: 'Spracovateľ platieb',
    paymentStatus: 'Stav',
    placeholder: 'Zástupný symbol',
    priceConditions: 'Cenové podmienky',
    priceConditionsPlural: 'Cenové podmienky',
    priceConditionsSingular: 'Cenová podmienka',
    radioOptions: 'Možnosti rádiových atribútov',
    radioPlural: 'Rádiové polia',
    radioSingular: 'Rádio',
    redirect: 'Presmerovať',
    replyTo: 'Odpovedať komu',
    required: 'Povinné',
    selectOptions: 'Vyberte položku Možnosti',
    selectPlural: 'Vyberte Polia',
    selectSingular: 'Vyberte',
    statePlural: 'Štátne polia',
    stateSingular: 'štátu',
    staticValue: 'Statická hodnota',
    subject: 'Predmet',
    submitButton: 'Odoslať štítok tlačidla',
    subtract: 'Odčítať',
    textareaPlural: 'Textarea Fields',
    textareaSingular: 'Textarea',
    textPlural: 'Textové polia',
    textSingular: 'Text',
    title: 'Názov',
    token: 'žetón',
    uploadCollection: 'Nahrať kolekciu',
    uploadCollectionDescription: 'Vyberte, do ktorej kolekcie odovzdania sa majú ukladať súbory',
    uploadFieldPlural: 'Nahrať polia',
    uploadFieldSingular: 'Nahrať',
    urlToRedirectTo: 'Adresa URL na presmerovanie',
    value: 'Hodnota',
    valueOfField: 'Hodnota poľa',
    valueType: 'Typ hodnoty',
  },
}

export const sk: PluginLanguage = {
  dateFNSKey: 'sk',
  translations: skTranslations,
}
